module.exports = __webpack_public_path__ + "img/natudrin-depoimento-4.77d0ea52.jpg";